import { Helmet } from "react-helmet";
import { Col, Row, Table } from 'react-bootstrap'
import { Titlefourth } from "../General";
const estadosFinancieros = [
    {
        name: '2020',
        file: '/files/estados-financieros/2020.pdf'
    },
    {
        name: '2021',
        file: '/files/estados-financieros/2021.pdf'
    },
    {
        name: '2022',
        file: '/files/estados-financieros/2022.pdf'
    },
    {
        name: '2023',
        file: '/files/estados-financieros/2023.pdf'
    },
    {
        name: '2024',
        file: '/files/estados-financieros/2024.pdf'
    }
]
const EstadosFinancieros = () => {
    return <>
        <img src="/files/estados-financieros/estados-cuenta.jpg" />
        <div className={'bg-white px-5 pb-5 border-bottom-yellow'}>
            <Helmet>
                <title>{'Enrolamiento - Vimenca Western Union'}</title>
            </Helmet>
            <Row className="pt-5">
                <Col>
                    <Table striped borderless hover>
                        <tbody>
                            {estadosFinancieros.reverse().map(ef => {
                                return <tr>
                                    <td>
                                        <Titlefourth value={ef.name} />
                                    </td>
                                    <td className="text-right">
                                        <div className="mt-1">
                                            <a
                                                className="btn-sm btn-secondary "
                                                href={ef.file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Descargar
                                            </a></div>
                                    </td>

                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    </>
}

export default EstadosFinancieros;